<template>
  <div>
    <b-modal ref="scannerExportModal" title="scannerExportModal" size="lg" @hidden="hiddenModal">
      <div slot="modal-title">
        <div class="d-flex">
          <h5 class="modal-title">{{$t('buttons.operations.export_from_scanner')}}</h5>
        </div>
      </div>
      <div>
        <b-row>
          <b-col class="d-flex justify-content-end">
            <b-btn variant="outline-danger" size="sm"
                   title="Delete selected operations and packages"
                   @click="deleteSelectedRows">
              {{$t('buttons.common.delete')}}
            </b-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <ag-grid-vue class="ag-theme-balham grid" :columnDefs="columns"
                         :gridOptions="gridOptions"></ag-grid-vue>
          </b-col>
        </b-row>
      </div>
      <div slot="modal-footer" class="w-100 text-center">
        <input enctype="multipart/form-data" type="file" ref="selectFile" @change="loadFile" accept=".txt">
        <b-btn size="sm" @click="chooseFile" title="Load file ws_SCAN.txt">
          {{$t('buttons.common.load_file')}}
        </b-btn>
        <b-btn size="sm" variant="success" style="margin-left: 70px;" @click="createOperations">
          {{$t('buttons.common.save')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import {
    formatNumber,
    alignCells,
    getNodeChildDetails,
    addGroupingInResponseData,
    autoResize,
    notificationsRenderer
  } from '@/helpers/renderHelpers';
  import { translateColumns } from '@/helpers/translate-helper';
  import { handlerResponse, setNotifyData, getFile } from '@/helpers/commonHelpers';

  export default {
    components: {
      AgGridVue
    },
    data() {
      return {
        columns: [{
          field: 'grouping',
          minWidth: 110,
          headerName: '',
          cellRenderer: 'agGroupCellRenderer',
          checkboxSelection: true,
        },
          {headerName: 'operation', field: 'process_name'}, {
            headerName: 'date',
            field: 'start_date'
          }, {headerName: 'package_nr', field: 'package_nr', editable: true}, {
            headerName: 'package_name',
            field: 'package_name'
          }],
        gridOptions: {
          animateRows: true,
          getNodeChildDetails: getNodeChildDetails,
          onCellValueChanged: this.onCellValueChanged,
          rowSelection: 'multiple',
          stopEditingWhenGridLosesFocus: true,
          defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            valueFormatter(params) {
              return formatNumber(params.value, null)
            },
            cellStyle(params) {
              return alignCells(params);
            },
            tooltipValueGetter(params) {
              if (params.data.package_name) {
                return 'This package is on stock';
              }
            }
          },
          onRowDataChanged() {
            autoResize(this);
          },
          onGridReady() {
            this.api.showNoRowsOverlay();
          }
        },
        splittingRowsSymbol: '\n',
        processSeparate: 'PROCESS',
        timeSeparate: 'TIME',
        operationsData: []
      }
    },
    methods: {
      chooseFile() {
        this.$refs['selectFile'].click();
      },
      loadFile() {
        const file = this.$refs['selectFile'].files[0];
        if (file.name === 'ws_SCAN.txt') {
          const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Content-Disposition': `form-data; filename=${encodeURIComponent(file.name)}`
          };
          getFile(file).then((data) => {
            const requestBody = {
              'content': data.base64StringFile,
              'fileType': data.fileType
            };
            this.gridOptions.api.showLoadingOverlay();
            this.$http.post(`woodware/movements_from_scan/`, JSON.stringify(requestBody), {headers})
              .then(handlerResponse).then(response => {
              this.operationsData = response;
              this.setGridData();
            });
          });
          this.$refs['selectFile'].value = '';
        } else {
          const file = 'ws_SCAN.txt';
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.select_specific_file`, {file}),
            '', 'warn'));
        }
      },
      hiddenModal() {
        if (this.gridOptions && this.gridOptions.api) {
          this.gridOptions.api.setRowData([]);
        }
        if (this.$refs['selectFile']) {
          this.$refs['selectFile'].value = '';
        }
      },
      getPackageNamesAtPackageNumbers(operationsData, params) {
        this.gridOptions.api.showLoadingOverlay();
        return new Promise((resolve, reject) => {
          this.$http.get(`woodware/movement_data_list_by_package_nr/`, {params}).then(handlerResponse).then(response => {
            this.setPackagesNamesByPackagesIdsForOperations(operationsData, response);
            resolve(response);
          }).catch(error => {
            console.log(error);
            this.gridOptions.api.hideOverlay();
            reject(error);
          });
        })
      },
      setPackagesNamesByPackagesIdsForOperations(operationsData, packagesData) {
        packagesData.forEach(item => {
          operationsData.forEach(operation => {
            if (operation.children && operation.children.length) {
              const operationPackets = operation.children;
              operationPackets.forEach(packageItem => {
                if (packageItem.package_nr === item.package_nr) {
                  packageItem.package_name = item.name;
                  packageItem.id = item.id;
                }
              });
            }
          });
        });
      },
      setGridData() {
        this.gridOptions.api.setRowData(addGroupingInResponseData(this.operationsData));
        this.gridOptions.api.forEachNode(node => node.setExpanded(true));
      },
      onCellValueChanged(param) {
        const currentPackageNr = param.data.package_nr;
        if (currentPackageNr) {
          const oldPackageNr = param.oldValue, newPackageNr = param.newValue;
          if (newPackageNr !== oldPackageNr) {
            const params = {package_nr: newPackageNr};
            this.getPackageNamesAtPackageNumbers(this.operationsData, params).then((response) => {
              this.operationsData.forEach(operation => {
                if (operation.children) {
                  operation.children.forEach(packageItem => {
                    if (packageItem.package_nr === currentPackageNr && !response.length) {
                      packageItem.package_name = null;
                    }
                  });
                }
              });
              this.setGridData();
            });
          }
        }
      },
      createOperations() {
        const packages = [].concat(...this.operationsData.map(item => item.children)),
          packagesOnStock = packages.filter(item => item.package_name);
        if (this.operationsData.length) {
          if (packages.length !== packagesOnStock.length) {
            this.$swal.fire({
              title: this.$i18n.t(`modal_dialogs.sure_attempt`),
              text: this.$i18n.t(`modal_dialogs.not_all_packets_in_stock`),
              icon: 'warning',
              showCancelButton: true,
              cancelButtonText: this.$i18n.t(`buttons.common.cancel`)
            }).then(result => {
              if (result.value) {
                this.iterateOperationsData();
              }
            });
          } else {
            this.iterateOperationsData();
          }
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.operations.operations_list_empty`), '', 'warn'));
        }
      },
      async iterateOperationsData() {
        for (const [index, item] of this.operationsData.entries()) {
          const packages = item.children.filter(item => item.package_id).map(item => item.package_id);
          const requestData = {
            start_date: item.start_date,
            process: item.process_id,
            wobject: item.wobject_id,
            packages
          };
          await this.delayedCreatingOperation(requestData);
        }
        this.$store.dispatch(`woodware/fetchOperations`);
        this.$refs['scannerExportModal'].hide();
      },
      createOperation(requestData) {
        return new Promise(resolve => {
          this.$http.post(`woodware/create_movement_with_stock_packages/`, requestData).then(handlerResponse).then((response) => {
            const operationName = response.name;
            this.$notify(setNotifyData('', this.$i18n.t(`notifications.operations.operation_name_created`,
              {operationName}), 'success'));
            resolve(response);
          }).catch(error => {
            notificationsRenderer(error.data, 'error');
          });
        });
      },
      async delayedCreatingOperation(requestData) {
        await this.createOperation(requestData);
      },
      deleteSelectedRows() {
        const selectedRows = this.gridOptions.api.getSelectedRows();
        const selectedOperations = selectedRows.filter(item => item.children),
          selectedPackages = selectedRows.filter(item => !item.children);
        if (selectedRows.length) {
          selectedOperations.forEach(selectedOperation => {
            this.operationsData.forEach((operation, operationIndex) => {
              if (operation.movement_grid_id === selectedOperation.movement_grid_id) {
                this.operationsData.splice(operationIndex, 1);
              }
            });
          });
          if (selectedPackages.length) {
            this.operationsData.forEach((operation, operationIndex) => {
              const packages = operation.children;
              if (packages && packages.length) {
                selectedPackages.forEach(selectedPackageItem => {
                  packages.forEach((packageItem, packageIndex) => {
                    if (selectedPackageItem.package_id === packageItem.package_id) {
                      this.operationsData[operationIndex].children.splice(packageIndex, 1);
                    }
                  });
                });
              }
            });
          }
          this.setGridData();
        }
      }
    },
    mounted() {
      translateColumns.call(this, this.columns);
      this.gridOptions.api && this.gridOptions.api.setColumnDefs([]);
      this.gridOptions.api && this.gridOptions.api.setColumnDefs(this.columns);
      this.$root.$on('openScannerExportModal', () => {
        if (this.$refs['scannerExportModal']) {
          this.$refs['scannerExportModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openScannerExportModal');
      if (this.$refs['selectFile']) {
        this.$refs['selectFile'].value = '';
      }
    }
  }
</script>

<style scoped>
  .grid {
    height: 500px;
  }

  input[type='file'] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/ScannerExportModal.vue